import React from 'react';
import { Formik, Form, Field } from 'formik';
import 'react-html5-camera-photo/build/css/index.css';
import Camera from 'react-html5-camera-photo';
import { withRouter } from 'react-router-dom';
import { Persist } from 'formik-persist';

class PhotoForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            PhotoId: 'PhotoSelfieKTP',
            openModalPhoto: true,
        }

        this.handleTakePhoto = this.handleTakePhoto.bind(this);
    }

    handleTakePhoto = (dataUri, setFieldValue) => {
        setFieldValue(this.state.PhotoId, dataUri);
        this.setState({ openModalPhoto: false });
    };

    render() {
        return (
            <Formik
                onSubmit={(values, actions) => {
                    console.log(values);
                    actions.setSubmitting(false);
                }}
            >

                {({ errors, touched, values, isValid, setFieldValue, setFieldTouched }) => (
                    <Form>
                        {(this.state.openModalPhoto) ?
                        <div className="camera-wrapper">
                            <Camera
                                onTakePhoto={(dataUri) => this.handleTakePhoto(dataUri, setFieldValue)}
                                isImageMirror={false}
                            />
                            </div>
                            : null}
                         Optionally display the captured image 
                        {values.PhotoSelfieKTP && (
                            <img src={values.PhotoSelfieKTP} alt="Captured" style={{ width: '100%', marginTop: '20px' }} />
                        )}
                        <button type="submit">Submit</button>
                        <Persist name="registrasi" />
                    </Form>
                )}

                {/*{formikProps => (*/}
                {/*    <Form>*/}
                {/*        <div className="camera-wrapper">*/}
                {/*            <Camera*/}
                {/*                onTakePhoto={(dataUri) => this.handleTakePhoto(dataUri, formikProps.setFieldValue)}*/}
                {/*                isImageMirror={false}*/}
                {/*            />*/}
                {/*        </div>*/}
                {/*        */}{/* Optionally display the captured image */}
                {/*        {formikProps.values.PhotoSelfieKTP && (*/}
                {/*            <img src={formikProps.values.PhotoSelfieKTP} alt="Captured" style={{ width: '100%', marginTop: '20px' }} />*/}
                {/*        )}*/}
                {/*        <button type="submit">Submit</button>*/}
                {/*        <Persist name="registrasi" />*/}
                {/*    </Form>*/}
                {/*)}*/}
            </Formik>
        );
    }
}

export default (PhotoForm);


// WEBPACK FOOTER //
// ./src/components/PhotoForm.js